
































































































































































































































































































































































































































































































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { mapState } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import ContactForm from './ContactForm.vue'
import DirectionsMap from './DirectionsMap.vue'
import LotImage from '@/components/consumer_map_v3/LotImage.vue'
import VirtualTourWrapper from '~/components/shared/VirtualTourWrapper.vue'
import ImagesGallery from '~/components/shared/imagesGallery.vue'
import LotInfo, { Schedule } from '~/models/lotInfo'
import { PublicProject } from '~/models/project'
import Plan from '~/models/plan'
import Lot from '~/models/lot'
import { FloorPlanImage } from '~/models/elevation'
import projectConfig from '~/assets/project-config.json'
import {
  streetViewMetadata,
  EMBED_BASE_URL,
  STREET_VIEW,
} from '~/api/gmaps.api'
import { LotTypes } from '~/enums/lots'

import globalStyling from '~/mixins/globalStyling'
import LotUtilsMixin from '~/mixins/LotUtilsMixin'
import DefaultImage from '~/mixins/defaultImage'
import { getElevations } from '~/api/elevations.api'
import { Elevation } from '~/models'
import { parseHomeParams } from '~/api/consumer_map.api'
import { getParentURL } from '~/utils/utils'
import ShareModal from '~/components/consumer_map/ShareModal.vue'
import { hasHTMLCode } from '~/utils/htmlDetection'

import 'swiper/css/swiper.css'

@Component({
  components: {
    ContactForm,
    Swiper,
    SwiperSlide,
    VirtualTourWrapper,
    DirectionsMap,
    ImagesGallery,
    LotImage,
    ShareModal,
  },
  mixins: [globalStyling, LotUtilsMixin, DefaultImage],
  computed: {
    ...mapState('consumer-map', {
      parentPageBaseURL: 'parentPageBaseURL',
    }),
  },
})
export default class SideModal extends mixins(
  globalStyling,
  LotUtilsMixin,
  DefaultImage
) {
  @Prop({ default: null }) lotInfo: LotInfo
  @Prop({ default: null }) project: PublicProject
  @Prop({ default: null }) models: Lot[]
  @Prop({ default: null }) filters: any

  activeView: 'detail' | 'contact' = 'detail'
  activeTab: number = 0
  tabs = [
    'Photos',
    'Home Plan Options',
    'Navigation',
    'Virtual Tour',
    'Google Street',
  ]

  showVirtualTour: boolean = false
  currentSlideImage: number = 1
  streetViewMeta = { status: 'ZERO_RESULTS' }
  lotType: string = LotTypes.HOME
  elevations: Array<Elevation> = []
  elevationsLoading: Boolean = false
  showShareModal: Boolean = false
  sharedUrl: string = ''
  parentPageBaseURL!: string
  LotTypes: any = LotTypes

  created() {
    this.lotType = this.getLotType(this.project, this.lotInfo)
  }

  mounted(): void {
    this.getStreetViewMetadata(this.lotInfo)
    this.lotType = this.getLotType(this.project, this.lotInfo)
    if (this.isHomeSite) {
      this.getElevations()
    }
  }

  getBuilderWebsite(): string {
    if (this.lotInfo.builder_website) {
      return this.lotInfo.builder_website
    }
    return this.lotInfo?.builder?.website
  }

  async getElevations(): Promise<void> {
    this.elevationsLoading = true
    const filtersApplied = { ...this.filters }
    if (filtersApplied.builder) {
      delete filtersApplied.builder
    }
    try {
      const response = await getElevations(
        null,
        this.lotInfo?.id,
        null,
        null,
        'max',
        null,
        this.$route.params.slug,
        this.lotInfo?.builder?.id,
        null,
        null,
        parseHomeParams(filtersApplied)
      )
      this.elevations = response.results
    } catch (error) {
      throw new Error(error)
    } finally {
      this.elevationsLoading = false
    }
  }

  get gallery(): Array<string> {
    if (!this.isHomeSite) {
      return this.lotInfo.gallery
    } else if (this.lotInfo.additional_photos.length) {
      return this.lotInfo.additional_photos
    } else {
      return [this.imgSrc]
    }
  }

  get floorPlanGallery(): Array<FloorPlanImage> {
    if (this.isHomeSite) {
      return this.elevations
        .filter((elevation: any) => elevation?.photo && !elevation.disabled)
        .map((e: any) => {
          const photo: FloorPlanImage = {
            planName: e.plan?.name,
            elevationName: e.name,
            beds: e.plan?.beds,
            baths: e.plan?.baths,
            sqft: e.plan?.sqft,
            image: e.photo,
          }
          if (this.price(this.lotInfo, this.lotType) !== 'Call for Details') {
            photo.startingPrice = e.plan?.price
          }
          return photo
        })
    } else if (this.isHome || this.isModel) {
      const images =
        this.lotInfo.architectural_submission?.master_plan?.plan
          ?.floor_plan_images
      if (images)
        return images
          .filter((floorPlan: any) => floorPlan?.source)
          .map((fp: any) => fp.source)
      return []
    }
    return []
  }

  get isHome(): boolean {
    return this.lotType === LotTypes.HOME
  }

  get isModel(): boolean {
    return this.lotType === LotTypes.RESERVED
  }

  get isHomeSite(): boolean {
    return this.lotType === LotTypes.HOME_SITE
  }

  get cssVariablePrefix(): string {
    return this.lotType === LotTypes.HOME_SITE ? '--ad-sp-hs-' : '--ad-sp-h-'
  }

  getPropertyName(fieldName: string): string {
    return `${this.cssVariablePrefix}${fieldName.split(' ').join('-')}`
  }

  private async getStreetViewMetadata(lotInfo: LotInfo) {
    this.streetViewMeta = await streetViewMetadata(
      lotInfo.latitude,
      lotInfo.longitude,
      process.env.mapApiKey
    )
  }

  get plan(): Plan {
    return this.lotInfo.architectural_submission?.master_plan?.plan
  }

  get imgSrc() {
    if (this.lotType === LotTypes.HOME_SITE)
      return (
        this.lotInfo.homesite_photo ||
        this.lotInfo.place_holder_thumbnail ||
        this.defaultImage()
      )

    return (
      this.lotInfo.listing_photo_url ||
      this.lotInfo.place_holder_thumbnail ||
      this.defaultImage()
    )
  }

  get builderImg() {
    return this.lotInfo?.builder?.logo || this.project?.logo
  }

  get overview() {
    return (
      this.lotInfo.description ||
      this.lotInfo.architectural_submission?.master_plan?.plan?.description ||
      ''
    )
  }

  get additionalDetails() {
    let details: any
    if (this.lotType === LotTypes.HOME_SITE)
      details = {
        'Lot Size': this.lotInfo.size,
        'Lot Number': this.lotInfo.number,
        Block: this.lotInfo.block,
        'Parcel Id': this.lotInfo.parcel_id,
        Acreage: this.lotInfo.acreage,
        Neighborhood: this.lotInfo.neighborhood,
        // Overview: this.lotInfo.description,
      }
    else {
      details = {
        Plan: this.lotInfo.architectural_submission?.master_plan?.plan?.name,
        Elevation: this.lotInfo.architectural_submission?.master_plan?.name,
        'Sq Ft': this.lotInfo.architectural_submission?.listing_sqft,
        Architecture:
          this.lotInfo.architectural_submission?.master_plan?.style?.name,
        'Lot Size': this.lotInfo.size,
        'Lot Number': this.lotInfo.number,
        Block: this.lotInfo.block,
        'Parcel Id': this.lotInfo.parcel_id,
        Acreage: this.lotInfo.acreage,
        Neighborhood: this.lotInfo.neighborhood,
        beds: this.lotInfo.architectural_submission?.listing_beds,
        baths: this.lotInfo.architectural_submission?.listing_baths,
        // Overview: this.lotInfo.description,
        'Date Available': this.lotInfo.architectural_submission?.available_on,
      }
    }
    return Object.entries(details)
  }

  get features() {
    return this.lotInfo.features
  }

  get schedule() {
    return this.lotInfo.schedule.map((schedule: Schedule) => {
      const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
      const times = weekdays.map((day) => schedule[day])

      // Check if all weekdays have the same time
      const isSameWeekdayTime = times.every((time) => time === times[0])

      const result: { [key: string]: string } = {}
      if (isSameWeekdayTime) {
        result['Mon - Fri'] = times[0]
      } else {
        weekdays.forEach((day) => {
          result[day.charAt(0).toUpperCase() + day.slice(1)] = schedule[day]
        })
      }

      result.Saturday = schedule.saturday
      result.Sunday = schedule.sunday

      return Object.entries(result)
    })
  }

  // If the model has a model_home_address_id this will return the corresponding lot to the id
  redirectModel(model: any) {
    if (model && model.model_home_address_id) {
      const newModel = this.models.find(
        (newModel) => newModel.id === model.model_home_address_id
      )
      return newModel || model
    }
    return model
  }

  get model() {
    // find all the models from the same builder
    const models = this.models?.filter(
      (model: any) => model?.builder?.name === this.lotInfo.builder?.name
    )
    // if there aren't models bail
    if (!models || !models?.length) {
      return undefined
    }

    // the model that matches the plan and the elevation is the one that we need to show
    const lot_master_plan = this.lotInfo.architectural_submission?.master_plan
    let matchingModel = null

    // Suggest model that matches lot size
    const suggestedModel = models.find(
      (model) => model?.size === this.lotInfo.size
    )

    if (suggestedModel) {
      return this.redirectModel(suggestedModel)
    }

    // if the lot doesn't have a master plan return the first model of the builder
    if (!lot_master_plan) {
      return this.redirectModel(models[0])
    }

    matchingModel = models.find(
      (model) =>
        model.architectural_submission?.master_plan?.id ===
          lot_master_plan?.id &&
        model.architectural_submission?.master_plan?.plan?.id ===
          lot_master_plan?.plan?.id
    )

    // if there is not any model that matches the lot's elevation the suggest one based on the elevation size
    if (!matchingModel) {
      const matchingModelBySize = models.find((model) => {
        return model.architectural_submission?.master_plan?.plan.size.some(
          (size) => lot_master_plan?.plan.size.includes(size)
        )
      })
      return this.redirectModel(matchingModelBySize || models[0]) // if none is found then retrieves the first in the list of models
    }
    return this.redirectModel(matchingModel)
  }

  lotPrice(lotInfo: any, lotType: string) {
    const price = this.price(lotInfo, lotType)
    const callForDetailsLabel =
      projectConfig[this.project.slug]?.callForDetailsLabel || ''
    if (price === 'Call for Details') {
      return callForDetailsLabel || price
    }
    return price
  }

  get customPriceLabel(): string {
    const price = this.lotPrice(this.lotInfo, this.lotType)
    if (price === 'Call for Details') {
      return this.lotInfo.builder_phone
    }

    if (this.lotType === LotTypes.HOME_SITE)
      return (
        projectConfig[this.project.slug]?.homesitePriceLabel || 'Starting Price'
      )
    return projectConfig[this.project.slug]?.homePriceLabel || 'Listing Price'
  }

  get virtualTour(): string {
    return (
      this.lotInfo?.architectural_submission?.master_plan?.plan
        ?.virtual_tour_url || null
    )
  }

  setActiveTab(index: number = 0): void {
    this.activeTab = index
  }

  setShowVirtualTour(value: boolean): void {
    this.showVirtualTour = value
  }

  get gStreetMapUrl(): string {
    return `${EMBED_BASE_URL}${STREET_VIEW}?key=${process.env.mapApiKey}&location=${this.lotInfo.latitude},${this.lotInfo.longitude}&heading=236`
  }

  getPDFSummaryURL(): string {
    return `/o/api/map/consumer/${this.lotInfo.slug}/pdf_summary`
  }

  shareUrl() {
    const { origin, pathname } = window.location
    let output = ''
    const parentURL = getParentURL(this.parentPageBaseURL)
    output = parentURL.origin ? parentURL.origin : `${origin}${pathname}`
    output += `?slug=${this.lotInfo.slug}`
    this.sharedUrl = `${output}${parentURL.extraParams}`
    this.showShareModal = true
  }

  hasHTMLCode(value: string): boolean {
    return hasHTMLCode(value)
  }
}
